import { render } from "./GameRecommendationsFromFavoriteGames.vue?vue&type=template&id=67bbc1b8&scoped=true"
import script from "./GameRecommendationsFromFavoriteGames.vue?vue&type=script&lang=js"
export * from "./GameRecommendationsFromFavoriteGames.vue?vue&type=script&lang=js"

import "./GameRecommendationsFromFavoriteGames.vue?vue&type=style&index=0&id=67bbc1b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bbc1b8"]])

export default __exports__